<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const store = useStore();
const { t } = useI18n();

const url = computed(() => route.query.url);

onMounted(() => {
  // Carregar dashboard apps se não estiverem carregados
  if (store.getters['dashboardApps/getRecords'].length === 0) {
    store.dispatch('dashboardApps/get');
  }
});
</script>

<template>
  <div class="dashboard-app-page">
    <div class="dashboard-app-content">
      <iframe
        v-if="url"
        :src="url"
        class="dashboard-app-iframe"
        frameborder="0"
      />
      <div v-else class="dashboard-app-error">
        <p>{{ t('CONVERSATION_SIDEBAR.DASHBOARD_APPS.URL_NOT_FOUND') }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dashboard-app-page {
  height: 100vh;
  width: calc(100% - 200px);
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.dashboard-app-content {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.dashboard-app-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.dashboard-app-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6b7280;
}
</style>
